module.exports = "/assets/data/c3f7a9dfe42211b325cdb48cad5fb37f-NR35.data.json";